var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsJira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.765 0.296875H119.378C119.378 14.71 125.104 28.5328 135.296 38.7244C145.487 48.916 159.31 54.6416 173.723 54.6416H195.9V76.0536C195.919 106.04 220.223 130.344 250.209 130.364V10.7405C250.209 4.97427 245.535 0.296875 239.765 0.296875Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.198 60.2812H59.8118C59.8304 90.2676 84.1338 114.572 114.121 114.592H136.298V136.072C136.336 166.058 160.656 190.346 190.643 190.346V70.7268C190.643 64.9586 185.966 60.2822 180.198 60.2822V60.2812Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.596 120.232H0.208984C0.208984 150.246 24.5408 174.577 54.5536 174.577H76.7999V195.988C76.8195 225.947 101.081 250.241 131.041 250.298V130.677C131.041 124.909 126.364 120.232 120.596 120.232Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsJira);
export default __webpack_public_path__ + "static/media/skills-jira.826768e16749ef2839c28feab664804f.svg";
export { ForwardRef as ReactComponent };